export default __webpack_public_path__ + "static/media/n10.64dcf776.svg";